import React from 'react';
import { Gift } from 'lucide-react';
import { getIconByName } from './iconUtils';

/** Renders a subscription plan icon from admin-configured lucide name and optional badge color. */
export function SubscriptionPlanIconGlyph({
  icon,
  color,
  className = 'w-4 h-4',
  freeTier = false,
}: {
  icon?: string | null;
  color?: string | null;
  className?: string;
  /** When true and no icon, show gift (free / no plan). */
  freeTier?: boolean;
}): React.ReactElement {
  if (!icon && freeTier) {
    return <Gift className={`${className} text-gray-500 dark:text-gray-400`} />;
  }
  const IconComponent = getIconByName(icon || 'Award');
  const style = color ? { color } : undefined;
  const colorClass = color ? '' : 'text-blue-600 dark:text-blue-400';
  return <IconComponent className={`${className} ${colorClass}`.trim()} style={style} />;
}

export function subscriptionPlanBadgeStyle(color?: string | null): React.CSSProperties | undefined {
  if (!color) return undefined;
  return {
    backgroundColor: `${color}22`,
    borderColor: `${color}66`,
  };
}
